import React from 'react';
import { translate } from '../../../Services/translation';
import Icon from '../../Icon';
import { useNavigate } from 'react-router-dom';
import { remove as removeUser } from '../../../Actions/Person.action';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { getColor } from '../../../styling/mixins/colors';
import { fontFamilyBold, text } from '../../../styling/mixins/typography';
import { cells, grid } from '../../../styling/utils/grid';
import { breakpoint } from '../../../styling/mixins/breakpoints';
import Button from '../../Button';

const StyledUserMobileItem = styled.li`
  padding: 1.6rem;
  border: 1px solid ${getColor('grey', 300)};
  border-radius: 4px;
  margin-bottom: 1.6rem;

  .title {
    ${text('large')}
    ${fontFamilyBold}
    text-transform: capitalize;
    margin-bottom: 1.2rem;
  }

  .desc {
    ${grid}
    ${cells(2)}
    ${breakpoint('medium')} {
      ${cells(4)}
    }
  }

  .desc-cell {
    display: flex;
    flex-direction: column;
  }

  .sub-title {
    ${text('small')}
    color: ${getColor('grey', 600)};
    text-transform: uppercase;
  }

  .person-info {
    ${text('medium')}
  }

  .btn__wrapper {
    grid-column: span 2;
    display: flex;
    gap: 1.2rem;
    align-items: center;

    ${breakpoint('medium')} {
      grid-column: unset;
      justify-content: flex-end;
    }

    button {
      display: flex;
      align-items: center;
      width: 32px;
      height: 32px;

      &#edit {
        border-color: ${getColor('primary')};
        color: ${getColor('primary')};
      }

      &#delete {
        border-color: ${getColor('alert')};
        color: ${getColor('alert')};
      }
    }
  }
`;

const UserListItemMobile = ({ person }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (
    <StyledUserMobileItem>
      <p className="title">
        {person.firstName} {person.lastName}
      </p>
      <div className="desc">
        <div className="desc-cell">
          <p className="sub-title">{translate('mypage.person.email')}:</p>
          <p className="person-info">{person.email}</p>
        </div>
        <div className="desc-cell">
          <p className="sub-title">{translate('mypage.person.phone')}:</p>
          <p className="person-info">{person.phone}</p>
        </div>
        <div className="desc-cell">
          <p className="sub-title">{translate('mypage.person.role')}:</p>
          <p className="person-info">{person.role}</p>
        </div>
        {person.role !== 'Admin' && (
          <div className="btn__wrapper">
            <Button
              btnType="clear"
              btnSize="small"
              id="edit"
              onClick={() => navigate(`edit/${person.systemId}`)}
            >
              <Icon
                name="edit"
                className="color-primary"
                style={{
                  width: '16px',
                  height: '16px',
                }}
              />
            </Button>
            <Button
              btnType="clear"
              btnSize="small"
              id="delete"
              onClick={() => {
                dispatch(removeUser(person.systemId));
              }}
            >
              <Icon
                name="delete"
                className="color-alert"
                style={{
                  width: '16px',
                  height: '16px',
                }}
              />
            </Button>
          </div>
        )}
      </div>
    </StyledUserMobileItem>
  );
};

export default UserListItemMobile;
